import { Component, Input } from "@angular/core";
import type {
  CardOrderShipmentCarrier,
  CardOrderUpsTrackingActivity,
} from "../card-orders.interface";
import {
  formatUpsTrackingActivityLocation,
  formatUpsTrackingActivityWhen,
  getShipmentCarrierLabelKey,
  sortUpsTrackingActivitiesOldestFirst,
} from "../card-order.util";

@Component({
  selector: "app-ups-tracking-timeline",
  templateUrl: "./ups-tracking-timeline.component.html",
  styleUrls: ["./ups-tracking-timeline.component.scss"],
  standalone: false,
})
export class UpsTrackingTimelineComponent {
  @Input() trackingNumber: string | null = null;
  @Input() status: string | null = null;
  @Input() activities: CardOrderUpsTrackingActivity[] = [];
  @Input() delivered = false;
  @Input() compact = false;
  @Input() embedded = false;
  @Input() shipmentDescription: string | null = null;
  @Input() shipmentCarrier: CardOrderShipmentCarrier | null = null;
  @Input() collapsibleHistory = false;

  historyExpanded = false;

  readonly formatWhen = formatUpsTrackingActivityWhen;
  readonly formatLocation = formatUpsTrackingActivityLocation;
  readonly getShipmentCarrierLabelKey = getShipmentCarrierLabelKey;

  get orderedActivities(): CardOrderUpsTrackingActivity[] {
    return sortUpsTrackingActivitiesOldestFirst(this.activities);
  }

  get historyCollapsible(): boolean {
    return this.collapsibleHistory || this.compact;
  }

  get showHistory(): boolean {
    return !this.historyCollapsible || this.historyExpanded;
  }

  toggleHistory(): void {
    this.historyExpanded = !this.historyExpanded;
  }

  isCompletedStep(index: number): boolean {
    if (this.delivered) {
      return true;
    }
    return index < this.orderedActivities.length - 1;
  }

  isCurrentStep(index: number): boolean {
    if (this.delivered) {
      return false;
    }
    return index === this.orderedActivities.length - 1;
  }
}
